import { NgModule } from "@angular/core";
import { LoginFormModule } from "@gloria-public/login/views/components/login-form/login-form.module";
import { LoginDialogComponent } from "./login-dialog.component";

@NgModule({
  declarations: [LoginDialogComponent],
  providers: [],
  imports: [LoginFormModule],
})
export class LoginDialogModule {}
